module.exports = __webpack_public_path__ + "static/backleftleaf-bae32a6f3abf2d5e06ddd64c39ff1ef0.png";